import { render, staticRenderFns } from "./Convo.vue?vue&type=template&id=721a63f5&"
import script from "./Convo.vue?vue&type=script&lang=js&"
export * from "./Convo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports